import React from "react";
import { BookingWizardPage } from "./BookingWizardPage";

// The BookingWizardPage already handles both new bookings and editing existing ones
// It detects the :id parameter and loads the appropriate data
export const BookingEditPage: React.FC = () => {
  return <BookingWizardPage />;
};
